import { call, put, SagaGenerator, takeEvery } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ApplicationActions } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { fetchSagaFactory } from "../../../app/sagas/fetchSagaFactory";
import { RESOURCE_KEYS } from "../../../localization";
import { isArrayOf } from "../../../utilities/typeGuardUtils";
import { TEXTBAUSTEINE_TREE } from "../../../utilities/variables/documentModelName";
import { executeBusy } from "../../../utilities/workflowUtils";

import { importTextbausteine, ImportTextbausteinePayload } from "../action";
import { isTextbausteinImportData } from "../textbausteineTypeGuard";
import { getFvKeyFromTextbausteinVerfahrenNode, handleTextbausteinTransferError } from "../textbausteinSagaUtils";

export function* importTextbausteineSaga(): SagaGenerator<void> {
	yield* takeEvery(importTextbausteine.match, function* (action: Action<ImportTextbausteinePayload>) {
		yield* call(executeBusy, function* () {
			yield* call(handle, action);
		});
	});
}

function* handle(action: Action<ImportTextbausteinePayload>): SagaGenerator<void> {
	const fachverfahrenKey = yield* call(
		getFvKeyFromTextbausteinVerfahrenNode,
		action.payload.nodeIdentifier,
		action.payload.activityId
	);
	if (!fachverfahrenKey) {
		return;
	}

	if (!isArrayOf(isTextbausteinImportData)(action.payload.textbausteinImportData)) {
		yield* call(
			handleTextbausteinTransferError,
			fachverfahrenKey,
			RESOURCE_KEYS.features.notification.error.textbausteine.invalidImportFile,
			"Not a textbausteine import file."
		);
		return;
	}

	yield* call(
		fetchSagaFactory(
			{
				relativeUrl: `/textbausteine/import?fachverfahrenKey=${fachverfahrenKey}`,
				method: "POST",
				body: JSON.stringify(action.payload.textbausteinImportData)
			},
			function* handleResponse(_) {
				yield* put(
					ApplicationActions.startMainActivityRequested({
						descriptor: { model: TEXTBAUSTEINE_TREE, engine: "tree" }
					})
				);
			},
			function* handleError(error) {
				yield* call(
					handleTextbausteinTransferError,
					fachverfahrenKey,
					RESOURCE_KEYS.features.notification.error.textbausteine.import,
					error
				);
			}
		)
	);
}
